
                import Handlebars from 'handlebars/dist/handlebars.runtime';
                const templateFunction = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<tr key="
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + ">\n    <td>    \n    </td>\n    <td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"title") : depth0), depth0))
    + "</td>\n    <td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"created") : depth0), depth0))
    + "</td>\n    <td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"category") : depth0), depth0))
    + "</td>\n    <td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"content") : depth0), depth0))
    + "</td>\n    <td>"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"dates") : depth0), depth0))
    + "</td>\n    <td class=\"center\">\n        <button type=\"button\"  class=\"edit-todo__btn btn\">\n             <i class=\"material-icons edit\" id='"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-editBtn'>edit</i>\n        </button>\n    </td>\n    <td class=\"center\">\n        <button type=\"button\"  class=\"archived-todo__btn btn\">\n            <i class=\"material-icons archive\" id='"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-archiveBtn'>archive</i>\n        </button>\n    </td>\n    <td class=\"center\">\n        <button type=\"button\" class=\"delete-todo__btn btn\">\n            <i class=\"material-icons remove\" id='"
    + alias2(alias1((depth0 != null ? lookupProperty(depth0,"id") : depth0), depth0))
    + "-deleteBtn'>remove</i>\n        </button>\n    </td>\n</tr>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = lookupProperty(helpers,"each").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"todos") : depth0),{"name":"each","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":26,"column":9}}})) != null ? stack1 : "");
},"useData":true});
                export default templateFunction;
                